import { Link } from 'react-router-dom';

import { ROUTES, SECTION_IDS, SERVICE_QUERY_PARAM } from '../../../core/constants/navigation';
import { SERVICES } from '../../../core/constants/services';
import Reveal from '../../../common/components/Reveal/Reveal';
import ResponsiveImage from '../../../common/components/ResponsiveImage/ResponsiveImage';
import SectionHeading from '../../../common/components/SectionHeading/SectionHeading';
import { IconArrowRight, IconCheck, IconCode, IconCompass, IconMegaphone, IconVideo } from '../../../common/icons';

import '../styles/services.css';

const SERVICE_ICONS = {
    asesoria:    IconCompass,
    marketing:   IconMegaphone,
    audiovisual: IconVideo,
    web:         IconCode,
};

export default function Services() {
    return (
        <section id={SECTION_IDS.SERVICES} className="services" aria-labelledby="services-title">
            <div className="layout-container">
                <SectionHeading
                    headingId="services-title"
                    eyebrow="Servicios"
                    title="Una sola aliada para todo tu medio"
                    lead="Cuatro líneas de servicio que funcionan por separado o como un solo plan integral, según lo que tu proyecto necesite."
                />

                <ul className="services__grid">
                    {SERVICES.map((service, index) => {
                        const Icon = SERVICE_ICONS[service.id];
                        return (
                            <Reveal as="li" key={service.id} delay={(index % 2) * 120} className="services__item">
                                <article className="service-card">
                                    <div className="service-card__media">
                                        <ResponsiveImage
                                            name={service.image}
                                            sizes="(min-width: 1024px) 580px, (min-width: 768px) 46vw, 92vw"
                                            width={1200}
                                            height={800}
                                            className="service-card__image"
                                            alt={service.imageAlt}
                                        />
                                        <span className="service-card__number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
                                    </div>
                                    <div className="service-card__body">
                                        <span className="service-card__icon"><Icon /></span>
                                        <h3 className="service-card__title">{service.title}</h3>
                                        <p className="service-card__summary">{service.summary}</p>
                                        <ul className="service-card__list">
                                            {service.items.map(item => (
                                                <li key={item} className="service-card__list-item">
                                                    <IconCheck />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                        <Link
                                            to={{ pathname: ROUTES.HOME, search: `?${SERVICE_QUERY_PARAM}=${service.id}`, hash: `#${SECTION_IDS.CONTACT}` }}
                                            className="service-card__link"
                                        >
                                            Cotizar {service.shortTitle.toLowerCase()}
                                            <IconArrowRight />
                                        </Link>
                                    </div>
                                </article>
                            </Reveal>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}
